
// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import debounce from 'lodash.debounce';
import TooltipPositionHelper from './helpers/TooltipPositionHelper';
import TooltipProps from './mixins/TooltipProps';
import {
  Refs, TooltipEvents, TooltipSlotName, TooltipProperty, TooltipDisplayType,
} from './enum';
import { ClientEvent } from '../../enums';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import { StyleColorSchemeType, StylePositionType } from '../../styles/enums';

const SCROLL_DEBOUNCE_DELAY = 100;

export default {
  name: 'Tooltip',
  mixins: [TooltipProps],
  data() {
    return {
      isContentVisible: false,
      tooltipPosition: {},
      arrowHorizontalPosition: {},
      arrowVerticalPosition: StylePositionType.Top,
      Refs,
      TooltipSlotName,
    };
  },
  computed: {
    contentStyles() {
      const verticalPositionStyles = this.tooltipPosition.top
        ? { top: `${this.tooltipPosition.top}px` }
        : { bottom: `${this.tooltipPosition.bottom}px` };
      const horizontalPositionStyles = this.tooltipPosition.left
        ? { left: `${this.tooltipPosition.left}px` }
        : { right: `${this.tooltipPosition.right}px` };

      return {
        ...verticalPositionStyles,
        ...horizontalPositionStyles,
      };
    },
    arrowStyles() {
      return this.arrowHorizontalPosition.left
        ? { left: `${this.arrowHorizontalPosition.left}px`, transform: 'translateX(-100%)' }
        : { right: `${this.arrowHorizontalPosition.right}px`, transform: 'translateX(100%)' };
    },
    arrowClassName() {
      return new StyleClassNamesBuilder('tooltip__content-arrow')
        .addConditionClassNames(Object.values(StylePositionType), this.arrowVerticalPosition)
        .build();
    },
    contentClasses() {
      return new StyleClassNamesBuilder('tooltip__content')
        .addConditionClassNames(
          Object.values(StyleColorSchemeType),
          this[TooltipProperty.ColorScheme],
        ).build();
    },
  },
  beforeDestroy() {
    this.closeTooltip();
  },
  methods: {
    // eslint-disable-next-line func-names
    handleScroll: debounce(function () { this.closeTooltip(); }, SCROLL_DEBOUNCE_DELAY),
    openTooltip(event) {
      this.isContentVisible = true;
      this.$emit(TooltipEvents.OpenTooltip, event);
      Vue.nextTick(() => this.setContentPosition());
      window.addEventListener(ClientEvent.Scroll, this.handleScroll);
    },
    closeTooltip() {
      this.isContentVisible = false;
      this.$emit(TooltipEvents.CloseTooltip);
      window.removeEventListener(ClientEvent.Scroll, this.handleScroll);
    },
    handleMouseLeave() {
      if (this[TooltipProperty.DisplayType] === TooltipDisplayType.Static) {
        return;
      }

      this.closeTooltip();
    },
    setContentPosition() {
      this.tooltipPosition = TooltipPositionHelper.getPosition(
        this.$refs[Refs.Content],
        this.$refs[Refs.Activator],
        this[TooltipProperty.Position] || {},
      );
      this.arrowHorizontalPosition = TooltipPositionHelper.getArrowHorizontalPosition(
        this.tooltipPosition,
        this.$refs[Refs.Activator],
      );
      this.arrowVerticalPosition = this.tooltipPosition.top > 0
        ? StylePositionType.Top
        : StylePositionType.Bottom;
    },
  },
};
